import React, { type ReactNode } from 'react';
import { TOTAL_STEPS } from '../../data/guideSteps';
import { SlideFrame } from './SlideFrame';
import { SlideHeader } from './SlideHeader';
type StepSlideProps = {
  step: number;
  title: string;
  continued?: boolean;
  visual: ReactNode;
  visualLabel: string;
  children: ReactNode;
};

/** Shared layout for every "Step N" slide: picture on the left, instructions on the right. */
export function StepSlide({
  step,
  title,
  continued = false,
  visual,
  visualLabel,
  children
}: StepSlideProps) {
  return <SlideFrame data-id="element-30" data-mp="14l1z9k3nj1x1">
      <SlideHeader eyebrow={`Step ${step} of ${TOTAL_STEPS}${continued ? ' · continued' : ''}`} title={title} data-id="element-31" data-mp="14opt6kd0dqca" />
      <div className="mt-[2.2cqw] grid min-h-0 flex-1 grid-cols-12 gap-[3cqw]" data-id="element-32" data-mp="1dn1j0k61wk3o">
        <figure role="img" aria-label={visualLabel} className="col-span-7 flex min-h-0 items-center justify-center" data-id="element-33" data-mp="3afl46z2524r4">
          {visual}
        </figure>
        <div className="col-span-5 flex min-h-0 flex-col justify-center gap-[1.8cqw]" data-id="element-34" data-mp="3fghj07o13bbb">
          {children}
        </div>
      </div>
    </SlideFrame>;
}